module.exports = __webpack_public_path__ + "media/images/admin/floors-492b2c2e365f5288446552f85b0dbf5f.svg";